import { render, staticRenderFns } from "./custom-icons.vue?vue&type=template&id=264659fe&scoped=true"
import script from "./custom-icons.vue?vue&type=script&lang=js"
export * from "./custom-icons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264659fe",
  null
  
)

export default component.exports